import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const RefundPaymentModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "RefundPaymentModalContainer" */
      './RefundPaymentModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
